import { NotifyJakeDTO } from '../_global/dto/userDtos'
import { BASE_URL } from './baseURL';

export const notifyJake = async ({ msg }) => {

    console.log('notifyJake() called')

    try {

        // prepare the payload
        const payload = new NotifyJakeDTO(msg)

        const response = await fetch(`/api/notifyJake`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json', // Ensure this is set correctly
            },
            body: JSON.stringify(payload),
            cache: 'no-store',

        });

        // if (!response.ok) {
        //     throw new Error('notifyJake() Network response was not ok');
        // }

        return

    } catch (error) {
        console.error('Error in notifyJake(): ' + error);
        throw error;
    }
};

export const  notifyJake2 = async ({ msg }) => {

    console.log('notifyJake2() called')

    try {

        // prepare the payload
        const payload = new NotifyJakeDTO(msg)

        const response = await fetch(`${BASE_URL}/adHocTwilioToJake2`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json', // Ensure this is set correctly
            },
            body: JSON.stringify(payload),
            cache: 'no-store',

        });

        // if (!response.ok) {
        //     throw new Error('notifyJake2() Network response was not ok');
        // }

        return

    } catch (error) {
        console.error('Error in notifyJake2(): ' + error);
        throw error;
    }
};
